// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.colleagues-widget .find-colleagues-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}
.colleagues-widget .fake-search {
  position: relative;
  height: 32px;
  width: 100%;
  border: 0.5px solid;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
}
.colleagues-widget .fake-search .search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 20px;
  color: #E0061C;
}
.colleagues-widget .fake-search .search-text {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
  color: #8e8e93;
  pointer-events: none; /* click passes through */
}

ion-spinner {
  margin: 0 auto;
  height: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/widgets/find-colleage-widget/find-colleague-widget.component.scss"],"names":[],"mappings":"AAII;EACI,aAAA;EACA,sBAAA;EACA,OAAA;EACA,aAAA;AAHR;AAMI;EACI,kBAAA;EAEA,YAAA;EACA,WAAA;EAEA,mBAAA;EACA,kBAAA;EAEA,uBAAA;EACA,eAAA;AAPR;AAQQ;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,cAAA;AANZ;AAQQ;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EAEA,eAAA;EACA,cAAA;EACA,oBAAA,EAAA,yBAAA;AAPR;;AAeA;EACI,cAAA;EACA,WAAA;AAZJ","sourcesContent":["  \n\n.colleagues-widget {\n\n    .find-colleagues-container {\n        display: flex;\n        flex-direction: column;\n        flex: 1;\n        min-height: 0;\n        // justify-content: space-between;\n    }\n    .fake-search {\n        position: relative;\n      \n        height: 32px;\n        width: 100%;\n      \n        border: 0.5px solid;\n        border-radius: 8px;\n      \n        background: transparent;\n        cursor: pointer;\n        .search-icon {\n            position: absolute;\n            left: 14px;\n            top: 50%;\n            transform: translateY(-50%);\n            font-size: 20px;\n            color: #E0061C;\n          }\n        .search-text {\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        transform: translate(-50%, -50%);\n        \n        font-size: 16px;\n        color: #8e8e93;\n        pointer-events: none; /* click passes through */\n        }\n      }\n      \n}\n  \n  \n\nion-spinner {\n    margin: 0 auto;\n    height: 8px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
